// extracted by mini-css-extract-plugin
module.exports = {"container":"i_EN","size-l":"i_EO","size-m":"i_EP","size-s":"i_EQ","size-xs":"i_ER","size-2xs":"i_ES","size-3xs":"i_ET"};